import { Flex, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  DescriptionInput,
  NameInput,
  Recurrence,
  Scheduling,
  Section,
  SectionContent,
  SectionHeader,
  StatusToggle,
} from 'ui'

export function GeneralInformation() {
  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <Text variant="title1">
            <FormattedMessage id="admin/promotions.form.general.title" />
          </Text>
          <Text tone="secondary">
            <FormattedMessage id="admin/promotions.form.general.subtitle" />
          </Text>
        </Flex>

        <StatusToggle name="general.active" />
      </SectionHeader>
      <SectionContent fluid>
        <NameInput name="general.name" />
        <DescriptionInput name="general.description" />
        <Scheduling
          names={{ start: 'scheduling.start', end: 'scheduling.end' }}
        />
        <Recurrence name="scheduling.recurrence" />
      </SectionContent>
    </Section>
  )
}
